// react
import { Map, fromJS } from "immutable";

export const initialState = fromJS({
	loginPage: Map(),
});

export default function uiState(state = initialState, action) {
	switch (action.type) {
		case "UI:UPDATE": {
			return state.setIn(action.keyPath, action.value);
		}

		default:
			return state;
	}
}
